import React, { Component } from 'react';
import { select, csv } from 'd3';
import { bubbleChart } from './bubbleChart';
import { transformData } from './transformData';
import Buttons from '../Buttons/Buttons.jsx';
import './bubbleChart.css'

export default class MetropolitanBubbleChart extends Component {
  constructor(props) {
    super(props);
    this.svgRef = React.createRef();
    this.state = { data: null };
  }

  componentDidMount() {
    csv('data/metropolitan/' + this.props.city + '.csv')
    .then((data) => transformData(data, this.props.filter))
    .then(data => {
      this.setState({ data }, () => this.renderWithD3(this.props, this.state));
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    let filter = nextProps.filter;

    if (filter !== this.props.filter || nextProps.width !== this.props.width || nextProps.city !== this.props.city) {
      csv('data/metropolitan/' + nextProps.city + '.csv')
      .then((data) => transformData(data, filter))
      .then(data => {
        this.setState({ data }, () => this.renderWithD3(nextProps));
      });

      return true;
    }

    return false;
  }

  renderWithD3(props) {
    if (!this.state.data) {
      return;
    }

    select(this.svgRef.current)
        .attr('width', props.width)
        .attr('height', props.height)
        .call(bubbleChart, Object.assign({}, props, this.state))

    return false;
  }

  updateFilter(filter) {
    this.props.update({filter});
  }

  render() {
    // if (this.props.city === "sydney" && this.props.filter !== "Total population") {
    //   this.updateFilter("Total population");
    // }

    let values = [
      {display: "Working age population", value: "Total population"},
      {display: "Working age arrivals 2011 - 2016", value: "NewIm"}];
    if (this.props.city === "sydney") values = [{display: "Working age population", value: "Total population"}, {display: "Working age arrivals 2011 - 2016", value: "NewIm"}]
    if (this.props.city === "auckland") values = [{display: "Working age population", value: "Total population"},{display: "Working age arrivals 2011 - 2013", value: "NewIm"}];

    return <React.Fragment>
              <Buttons
                values={values}
                callback={this.updateFilter.bind(this)}
                selected={this.props.filter}
              />
              <img className="bubble-chart-key" src="images/bubble-key.svg" />
              <svg className='bubble-chart' ref={this.svgRef} />
              <img className="bubble-chart-legend" src="images/bubble-colors.svg" />
            </React.Fragment>;
  }
}



// WEBPACK FOOTER //
// ./src/MetropolitanBubbleChart/index.js